module.exports = __webpack_public_path__ + "fonts/Roboto-Black.893fe146.ttf";